<template>
    <div>
        <Row>
            <Col span="24">
            <MyTable ref="myhistories" @changepage="changePage" @ontimechange="ontimechanged"></MyTable>
            </Col>
        </Row>
        <br />
    </div>
</template>
<script>
import HistoryData from './history_tbale.vue'
//import assistantData from '../../../static/api/assistantHistory.json'
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import store from '../../store'
import constJson from '../../api/common/constjson.js'
var constJ = new constJson()
export default {
    name: 'Assistant_History',
    data() {
        return {
            value1: "1",
            PageIndex: 1,
            PageSize: 10,
            selectTime: [],
            historyheader: [{
                    "title": "文件名",
                    "key": "filename",
                    // "align": "left",
                    // "width": "2000px"
                },
                {
                    "title": " ",
                    "key": "readtime",
                    // "align": "left",
                    // "width": "100px"
                }
            ],
        }
    },
    components: {
        'MyTable': HistoryData,
    },
    created: function() {
        var type = this.$router.history.current.query.q_type
        if (type === "cloudhistory") {
            //拉去数据
            if (store.state.user.userId !== undefined && store.state.user.userId.length > 1) {
                this.getHistoryFilesChanges(this.PageIndex)
            } else {
                //重登录
            }
        }
    },
    computed: {
        ...mapGetters(['sliderLength', 'getUserId'])
    },
    methods: {
        getHistoryFilesChanges(index, timeZone) {
            let currentIndex = index
            //console.log(currentIndex)
            constJ.reqFileAccessLogs(this.PageSize, currentIndex, timeZone).then(res => {
                console.log(res)
                var obj = null
                if (res.rtncode === 1) {
                    if (res.rltcode === 1) {
                        if (res.tbls.length > 0) {
                            obj = {
                                header: this.historyheader, //this.mockTableHeader(), //testData2.header,
                                tabrows: res.tbls[0].items,
                                total: res.tbls[0].total,
                                pageindex: res.tbls[0].pageindex,
                                index: currentIndex,
                                //classid: id,
                                tabname: "newfiles",
                            }
                        } else {
                            //默认
                            obj = {
                                header: this.historyheader, //testData2.header,
                                tabrows: null,
                                total: 0,
                                pageindex: 1,
                                index: currentIndex,
                                //classid: id,
                                tabname: "newfiles",
                            }
                        }
                    } else {

                    }
                } else {

                }
                this.$refs.myhistories.show(obj)
            }).catch(err => {
                console.log(err)
            })
        },
        reload() {
            //console.log("reload...")
            if (this.selectTime.length > 0) {
                this.getHistoryFilesChanges(this.PageIndex, this.selectTime)
            } else {
                this.getHistoryFilesChanges(this.PageIndex)
            }

            this.isRouterAlive = false
            //在修改数据之后使用 $nextTick，则可以在回调中获取更新后的 DOM
            this.$nextTick(() => {
                this.isRouterAlive = true
            })
        },
        changePage(index) {
            //console.log("changepage...")
            this.getHistoryFilesChanges(index, this.selectTime)
        },
        ontimechanged(timeZone) {
            this.selectTime = timeZone
            this.getHistoryFilesChanges(this.PageIndex, timeZone)
        },

    },
    watch: {
        getUserId: function() {
            console.log("assistant history...")
            console.log(this.getUserId)
            if (this.getUserId === undefined) {
                this.$router.push({ path: '/main/searchengine/search' })
            } else {
                if (this.getUserId.length > 1) {
                    this.reload()
                }
            }

        }
    },

}
</script>
<style scoped>
</style>